export const load = () => ({
	title: 'Step-by-step Guide To Measuring With A Laser',
	h1: 'How To Measure Using A Laser',
	description:
		'Learn how to measure your windows with your own Laser Measurement Tool.',
	showTitle: false,
	breadcrumbs: false,
	headerPosition: 'relative',
});
